import '../auth/auth.module'
import 'angular-messages'
import 'angular-animate'
import 'angular-resource'
import '../billing/billing.module'
import '../../lib/ng-password-strength.min.js'
import register from '../util/register'
import ConfirmationController from './ConfirmationController'
import SignupController from './SignupController'
import TermsOfServiceModalController from './TermsOfServiceModalController'
import SignupService from './SignupService'
import PasswordVerifyDirective from './PasswordVerifyDirective'
import ProperCase from './ProperCase.filter'
import SignupCrumbDirective from './SignupCrumbDirective'
import Registration from './Registration'

var signup = angular.module(
  'app.signup',
  [
    'ngMessages',
    'ngAnimate',
    'ngPasswordStrength',
    'ngRoute',
    'ngResource',
    'ui.bootstrap',
    'app.billing',
    'app.auth'
  ]
)

register('app.signup')
  .service('SignupService', SignupService)
  .factory('Registration', Registration.factory)
  .controller('SignupController', SignupController)
  .controller('ConfirmationController', ConfirmationController)
  .controller('TermsOfServiceModalController', TermsOfServiceModalController)
  .directive('passwordVerify', PasswordVerifyDirective)
  .directive('signupCrumb', SignupCrumbDirective)
  .filter('properCase', ProperCase)

signup.run()
